@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../global-styles/index.scss';

@mixin button() {
  border-radius: 6px;
  height: 48px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  border: none;
  gap: $spacing-8;
  padding: 0 $spacing-16;

  font-size: $typography-button-large-size;
  line-height: $typography-line-height;
  font-family: $typography-family;
}

.ghf {
  // Solid Community Blue
  &-primary-button {
    @include button();
    border: 1px solid $color-blue-default;
    background: $color-blue-default;
    color: $color-shade-white;
    &:link, &:visited {
      color: $color-shade-white;
    }
    &:hover {
      background: $color-blue-hover;
      border: 1px solid $color-blue-hover;
    }
  }

  // Outlined Inky Blue
  &-secondary-button {
    @include button();
    border: 1px solid $color-blue-default;
    color: $color-blue-default;

    &:hover {
      background-color: $color-blue-hover;
      color: $color-shade-white;
    }
  }

  // Default gray
  &-text-button {
    @include button();
    color: $color-gray-slate-default;

    &:hover {
      background: rgba(74, 74, 74, 0.05);
    }

    &:active {
      background: rgba(74, 74, 74, 0.1);
    }
  }
}
